import React from "react";
import bg_video from "./../assets/videos/bg-video.webm";
import { BsChevronDoubleDown } from "react-icons/bs";

function HeaderVideoSection() {
  return (
    <React.Fragment>
      <div className="h-screen bg-[#00000077] relative">
        {/* Video */}
        <video
          autoPlay
          muted
          loop
          className="absolute object-cover w-full h-full -z-10"
        >
          <source src={bg_video}></source>
        </video>
        {/* Heading */}
        {/* <div className="flex items-center justify-center h-screen z-10">
          <h1 className="xl:text-6xl text-3xl text-center text-primary font-extrabold py-6 sm:w-4/6 w-5/6 mx-auto">
            Welcome to the Monkey Kingdom
          </h1>
        </div> */}
        {/* DownArrow */}
        <div className="relative -top-16 w-full z-10">
          <div className="flex justify-center">
            <BsChevronDoubleDown className="text-3xl text-white animate-bounce" />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default HeaderVideoSection;
